import React from "react";
import SearchFilter from "components/searchFilter";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

export interface IPropsSearchAttendanceFilter {
  attendanceUpdateFilterTable: (...args) => void;
  attendanceChangeFieldValue: (...args) => void;
}

const AttendanceFilter = ({ attendanceUpdateFilterTable, attendanceChangeFieldValue }: IPropsSearchAttendanceFilter): JSX.Element => {
  const SEARCH_PLACEHOLDER = `${useTranslation({
    id: "quick_search",
  })}...`;

  return (
    <S.FilterContainer>
      <SearchFilter placeholder={SEARCH_PLACEHOLDER} updateFilter={attendanceUpdateFilterTable} changeFieldValue={attendanceChangeFieldValue} numbersTypedCharacters={2} />
    </S.FilterContainer>
  );
};

export default AttendanceFilter;
